import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProofSection() {
  return <section className="py-20 bg-white" data-id="element-140">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-141">
        <FadeIn data-id="element-142">
          <div className="bg-brand-teal text-brand-cream rounded-3xl p-8 md:p-12 shadow-xl relative overflow-hidden" data-id="element-143">
            {/* Decorative accent */}
            <div className="absolute top-0 right-0 w-32 h-32 bg-brand-gold/10 rounded-bl-full" data-id="element-144"></div>

            <h2 className="text-2xl md:text-3xl font-bold text-brand-gold mb-6 font-serif" data-id="element-145">
              Lo que cambia en 7 días:
            </h2>

            <p className="text-xl md:text-2xl leading-relaxed font-light" data-id="element-146">
              En la primera semana, la mayoría de las usuarias recuperan entre{' '}
              <strong className="text-white font-semibold" data-id="element-147">$50 y $150</strong>{' '}
              simplemente cancelando fugas que no sabían que existían.
            </p>
            <p className="text-lg md:text-xl mt-6 text-brand-cream/80 italic" data-id="element-148">
              Lo más importante no es el dinero, sino la desaparición del nudo
              en el estómago cada vez que suena una notificación del banco.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}